



























import { Component, Emit, Prop, Vue, Mixins, Watch } from 'vue-property-decorator';
import multiselect from 'vue-multiselect';
import {
    // AuthStoreHelper,
    RootStoreHelper
    // CompanyStoreHelper,
    // StoreHelper,
    // NotificationStoreHelper
} from '../../core/mixins';

@Component({
    components: {
        multiselect
    }
})
export default class PlusEyeButtons extends Mixins(RootStoreHelper) {
    @Prop() options: any;
    @Prop() optionSelected: any;
    @Prop() title: string;
    @Prop() disabledCreate: boolean;
    @Prop() disabledEdit: boolean;
    @Prop() loadingModify: boolean;
    @Prop({ default: false }) hideCreate: boolean;

    createButton() {
        this.$emit('create-btn-clicked');
    }

    @Emit()
    modifyButton() {}
}
